export enum videoAssetGroups {
  CollectionManagement = 'CollectionManagement',
  manageCollectiondetails = 'ManageCollectiondetails',
  ExamineeGroupDetails = 'ExamineeGroupDetails',
  ExamineeGroupManagement = 'ExamineeGroupManagement',
  ExamineeManagement = 'ExamineeManagement',
  ExamineeUpload = 'ExamineeUpload',
  ProfileSetting = 'ProfileSetting',
  Subscription = 'Subscription',
  ManageTagTypes = 'ManageTagTypes',
  TagManagement = 'TagManagement',
  UserTraining = 'UserTraining',
  LikertScalerScoringQuestions = 'LikertScalerScoringQuestions',
  DISCScoring = 'DISCScoring',
  QuestionScoring = 'QuestionScoring',
  ItemManagement = 'ItemManagement',
  ItemUpload = 'ItemUpload',
  TestManagement = 'TestManagement',
  ManageTestDetails = 'ManageTestDetails',
  TestSchedule = 'TestSchedule',
  ItemManagementDetails = 'ItemManagementDetails',

  EvaluateDescriptivequestions = 'EvaluateDescriptiveQuestions',
  Examineescorereport = 'ExamineeScoreReport',
  Examineetestreport = 'ExamineeTestReport',
  Itemreport = 'ItemReport',
  privateResponsereport = 'PrivateResponseReport',
  publicResponsereport = 'PublicResponseReport',
  Attendancereport = 'AttendanceReport'
}
